import { render, staticRenderFns } from "./roleGame.vue?vue&type=template&id=43d85b3b&scoped=true&"
import script from "./roleGame.vue?vue&type=script&lang=js&"
export * from "./roleGame.vue?vue&type=script&lang=js&"
import style0 from "./roleGame.vue?vue&type=style&index=0&id=43d85b3b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d85b3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d85b3b')) {
      api.createRecord('43d85b3b', component.options)
    } else {
      api.reload('43d85b3b', component.options)
    }
    module.hot.accept("./roleGame.vue?vue&type=template&id=43d85b3b&scoped=true&", function () {
      api.rerender('43d85b3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/subrole/components/roleGame.vue"
export default component.exports